export default{
  methods: {
    showSuccessMessage (text) {
      console.log(`success => ${text}`)
      // this.$vs.notify({
      //   title: 'Success',
      //   text,
      //   color:'success',
      //   position:'top-right',
      //   iconPack: 'feather',
      //   icon:'icon-check'})
    }
  }
}
